import * as React from 'react'
import { FC } from 'react'
import './Pills.scss'

export interface Pill {
    label: string
    slug: string
}

interface Props {
    items?: Pill[]
    activeSection?: string
    onClick?: (slug: string) => void
}

const Pills: FC<Props> = ({ items = [], activeSection = '', onClick }) => {
    return (
        <ul className="Pills">
            {items.map(({ label, slug }) => (
                <li className={activeSection === slug ? 'active' : ''} key={slug}>
                    <a href={`#${slug}`} onClick={() => onClick?.(slug)}>
                        {label}
                    </a>
                </li>
            ))}
        </ul>
    )
}

export default Pills
